export type ProductProgressKey =
  | 'defter-kasa'
  | 'kozmik-gunluk'
  | 'anilar-muzesi';

export const PRODUCT_PROGRESS: Record<ProductProgressKey, number> = {
  'defter-kasa': 100,
  'kozmik-gunluk': 50,
  'anilar-muzesi': 0,
};

export const PRODUCT_PROGRESS_KEYS = Object.keys(PRODUCT_PROGRESS) as ProductProgressKey[];

export function clampProgress(value: unknown): number {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 0;
  return Math.max(0, Math.min(100, Math.round(numeric)));
}

export function getProductProgress(key: ProductProgressKey): number {
  return PRODUCT_PROGRESS[key];
}
